import React from "react";
import { useTranslation } from "react-i18next";
import { useRetrieveCurrentPlanzone } from "@planzone/view-models";
import { UseCases } from "@planzone/core";

import { Button } from "@common/button";
import { Props } from "./types";
import styles from "./styles.scss";
import { useModal } from "@root/client/modal";

function Placeholder(props: Props) {
  const { t } = useTranslation();
  const { pushView } = useModal();
  const { planzone } = useRetrieveCurrentPlanzone();

  return (
    <div className={styles.placeholder}>
      <p>{t("membersList.groupPlaceholder")}</p>
      <Button
        className={styles.button}
        press={() =>
          pushView({
            data: {
              namespace: planzone.uuid,
              resourceType: "planzone",
            },
            key: UseCases.addResourceGroup,
          })
        }
      >
        Ajouter
      </Button>
    </div>
  );
}

export { Placeholder };
